import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { H } from '@farewill/ui'
import { DocumentList } from './list'
import Upload from './upload'
import PrivateRoute from 'components/private-route/containers'
import PreviewOverlay from './preview-overlay'
import { DocumentsProvider, useDocumentsContext } from './context'

const Documents = () => {
  const { id: probateCaseId } = useParams<{ id: string }>()
  const { documents, fetchDocuments, isFetchingDocuments } =
    useDocumentsContext()

  const isLoading = isFetchingDocuments && documents.length === 0

  useEffect(() => {
    fetchDocuments({ queryParams: { 'filter[probateCaseId]': probateCaseId } })
  }, [fetchDocuments, probateCaseId])

  return (
    <>
      <PrivateRoute
        path="/probate/cases/:probateCaseId/documents/:id"
        component={PreviewOverlay}
      />
      <H size="M">Upload documents</H>
      <Upload probateCaseId={probateCaseId} />
      <DocumentList documents={documents} isLoading={isLoading} />
    </>
  )
}

const DocumentsWithProvider = () => (
  <DocumentsProvider>
    <Documents />
  </DocumentsProvider>
)

export default DocumentsWithProvider
